import React, { useEffect, useState } from 'react';
import { Card, Table, Form, Pagination, Modal, Button, Row, Col, Badge } from 'react-bootstrap';
import { getWorkshopRegistrations } from '../../service/apiService';
import './ManageWorkshopRegistrations.css';
import * as XLSX from 'xlsx';

function ManageWorkshopRegistrations() {
  const [records, setRecords] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [skillFilter, setSkillFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const itemsPerPage = 50;

  // ✅ Fetch data
  useEffect(() => {
    const fetchData = async () => {
      const data = await getWorkshopRegistrations();
      setRecords(data);
      setFiltered(data);
    };
    fetchData();
  }, []);

  // ✅ Unique skill levels
  const skillLevels = [...new Set(records.map(r => r.skill_level))];

  // ✅ Search & Filter
  useEffect(() => {
    let result = records;

    if (search) {
      result = result.filter(r =>
        r.full_name.toLowerCase().includes(search.toLowerCase()) ||
        r.phone.includes(search)
      );
    }

    if (skillFilter) {
      result = result.filter(r => r.skill_level === skillFilter);
    }

    setFiltered(result);
    setCurrentPage(1);
  }, [search, skillFilter, records]);

  // ✅ Pagination
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const displayed = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const exportExcel = () => {

  const exportData = filtered.map((r, index) => ({
    No: index + 1,
    Name: r.full_name,
    Phone: r.phone,
    Place: r.place || '-',
    Course: r.course_name || '-',
    Year: r.course_year || '-',
    Batch: r.batch || '-',
    Institute: r.institute || '-',
    Skill: r.skill_level,
    Registered_On: r.created_at
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Workshop Registrations"
  );

  XLSX.writeFile(
    workbook,
    "Workshop_Registrations.xlsx"
  );
};

  return (
    <div className="manage-workshop-page">
      <h3 className="mb-4">Workshop Registrations</h3>

      <Card className="shadow-sm p-3 mb-4">
        <div className="filter-bar">
          <Form.Control
            type="text"
            placeholder="Search by name or phone"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Form.Select
            value={skillFilter}
            onChange={(e) => setSkillFilter(e.target.value)}
          >
            <option value="">All Skill Levels</option>
            {skillLevels.map((level, i) => (
              <option key={i} value={level}>{level}</option>
            ))}
          </Form.Select>
        </div>
<div className="d-flex justify-content-end mb-3">

  <Button
    variant="success"
    onClick={exportExcel}
  >
    Export Excel
  </Button>

</div>
        <Table striped bordered hover responsive className="workshop-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Place</th>
              <th>Course</th>
              <th>Year</th>
              <th>Batch</th>
              <th>Institute</th>
              <th>Skill</th>
              <th>Registered On</th>
            </tr>
          </thead>
          <tbody>
            {displayed.length ? (
              displayed.map((r, i) => (
                <tr
                  key={r.id}
                  onClick={() => {
                    setSelected(r);
                    setShowModal(true);
                  }}
                  className="clickable-row"
                >
                  <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                  <td>{r.full_name}</td>
                  <td>{r.phone}</td>
                  <td>{r.place || '-'}</td>
                  <td>{r.course_name || '-'}</td>
                  <td>{r.course_year || '-'}</td>
                  <td>{r.batch || '-'}</td>
                  <td>{r.institute || '-'}</td>
                  <td>
                    <Badge bg="info">{r.skill_level}</Badge>
                  </td>
                  <td>{r.created_at}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center text-muted">
                  No registrations found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <Pagination className="justify-content-center">
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} />
          </Pagination>
        )}
      </Card>

      {/* ✅ Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Registration Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <Row className="mb-3">
                <Col>
                  <h5>{selected.full_name}</h5>
                  <Badge bg="secondary">{selected.skill_level}</Badge>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <p><strong>Phone:</strong> {selected.phone}</p>
                  <p><strong>Place:</strong> {selected.place || '-'}</p>
                  <p><strong>Course:</strong> {selected.course_name || '-'}</p>
                  <p><strong>Year:</strong> {selected.course_year || '-'}</p>
                </Col>
                <Col md={6}>
                  <p><strong>Batch:</strong> {selected.batch || '-'}</p>
                  <p><strong>Institute:</strong> {selected.institute || '-'}</p>
                  <p><strong>Registered On:</strong> {selected.created_at}</p>
                </Col>
              </Row>

              <hr />

              <p><strong>Learning Expectation:</strong></p>
              <p className="text-muted">
                {selected.learning_expectation || 'Not provided'}
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ManageWorkshopRegistrations;
